import { CardType } from 'types/deck'
import { LocalCardData } from 'components/card/deckCards/deckCardWrapper'

import FoilSquare from 'components/card/controlsAndInfo/foilSquare'
import SaltMeter from 'components/cardDetailsPage/SaltMeter/SaltMeter'
import Legality from 'components/cardDetailsPage/Legality/Legality'

import { colorsToColorIdentityName } from 'utils/colorUtils'
import { getScryfallImageUrl } from 'utils/ImageUrl'
import { CardText, createTypeLine, manaArrayToElement } from 'components/misc/customIcons/ManaSymbol/helpers'

import styles from './drawerTopper.module.scss'
import mtgColorBorders from '../deckCards/mtgColorBorders.module.scss'

type Props = {
  card: CardType
  localCardData?: LocalCardData
  className?: string

  flipped?: boolean

  includeCardText?: boolean
  includeExtras?: boolean

  hideInDeckOptions?: boolean
  hideCardImage?: boolean
}

export const Background = ({ card, className = '' }: Props) => (
  <div
    className={`${styles.background} ${className}`}
    style={{ backgroundImage: `url(${getScryfallImageUrl(card.uid, card.flippedDefault, 'art_crop')})` }}
  />
)

const DrawerTopper = ({
  card,
  localCardData,

  className = '',

  flipped,

  includeCardText,
  includeExtras,

  hideInDeckOptions,
  hideCardImage,
}: Props) => {
  const colorIdentityName = colorsToColorIdentityName(card.colorIdentity)

  const colorBorderClassName = mtgColorBorders[colorIdentityName]
    ? mtgColorBorders[colorIdentityName]
    : mtgColorBorders.MultiColor

  return (
    <div className={`${styles.customMenuOption} ${className}`}>
      <div className={`${styles.cardMenu} ${includeCardText ? styles.autoHeight : ''} ${colorBorderClassName}`}>
        <div className={styles.cardName}>
          {card.name} {manaArrayToElement(card.castingCost)}
        </div>

        {includeCardText && (
          <>
            <div className={styles.typeLine}>{createTypeLine(card, false, true)}</div>

            <div className={styles.cardText}>
              {flipped ? (
                <CardText input={card.back?.text || card.text} />
              ) : (
                <CardText input={card.front?.text || card.text} />
              )}
            </div>
          </>
        )}

        {!hideInDeckOptions && (
          <div className={styles.info}>
            <span>Quantity {localCardData?.quantity ?? card.qty}</span>
            <FoilSquare card={card} includeLabel />
          </div>
        )}

        {includeExtras && (
          <>
            <div className={styles.info}>
              <span>Rarity: {card.rarity}</span>
            </div>
            <div className={styles.info}>
              <span>Collector number: {card.collectorNumber}</span>
            </div>
            <div className={styles.info}>
              <span>Artist: {card.artist}</span>
            </div>
            <div className={`${styles.info} ${styles.extraBooty}`}>
              <span>EDH Rank: {card.edhrecRank}</span>
            </div>

            <div className={styles.info}>
              <span>Commander game changer: {card.gameChanger ? 'Yes' : 'Nope'}</span>
            </div>
            <div className={styles.info}>
              <span>Canadian Highlander points: {`${card.canlanderPoints || 0}`}</span>
            </div>

            <SaltMeter salt={card.salt} />

            <Legality legalities={card.legalities} />
          </>
        )}

        {!hideCardImage && <Background card={card} localCardData={localCardData} />}
      </div>
    </div>
  )
}

export default DrawerTopper
